import { Component, inject } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { NavButtonComponent } from '../nav-button/nav-button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.html',
  imports: [NavButtonComponent],
  styleUrl: './cookie-consent.scss',
})
export class CookieConsentComponent {
  private router = inject(Router);
  contentParagraphKeys = [
    'cookie_consent_first_paragraph',
    'cookie_consent_second_paragraph',
    'cookie_consent_third_paragraph',
    'cookie_consent_fourth_paragraph',
    'cookie_consent_fifth_paragraph',
    'cookie_consent_subtitle', // Special key for the bold title
    'cookie_consent_sixth_paragraph',
  ];

  public i18n = inject(I18nService);
  gotoLogin() {
    this.router.navigate(['/login']);
  }
}
